import Spinner from './Spinner'
import './Spinner.css'

export default Spinner